import React, { PureComponent } from 'react'
import CoinRow from './coinRow';
import { List, AutoSizer } from 'react-virtualized';
import CoinsFilter from './coinsFilter'
import cn from 'classnames'
import './styles.css'

export class CoinsList extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      filterFavorites: false,
      filter: '',
      favorites: localStorage.favorites || ''
    }
  }

  listClicked = (e) => {

    const id =  e.target && e.target.getAttribute('data-coinid')
    id && this.props.selectCoin(id)

    const editID = e.target && e.target.getAttribute('data-editcoinid')
    editID && (this.props.editCoin(editID))

    const flagID = e.target && e.target.getAttribute('data-flagcoinid')
    flagID && this.toggleFavorite(flagID)
  }

  toggleFavorite = (id) => {
    const {favorites} = this.state

    favorites.indexOf(id) >= 0
      ? this.updateFavorites(favorites.replace(id, ''))
      : this.updateFavorites(favorites + id)
  }

  filterHits = (name) => name.toLowerCase().includes(this.state.filter.toLowerCase())
  isFavorite = (id) => !!(localStorage.favorites && localStorage.favorites.indexOf(id) >= 0)

  updateFavorites = (favString) => {
    this.setState({ favorites: favString })
    localStorage.setItem('favorites', favString)
  }

  getList = () => {
    const { filter, filterFavorites, favorites } = this.state;
    const { selectedCoin, adminMode, coins } = this.props
    return coins
      .filter(c => filterFavorites ? favorites.includes(c.id) : true )
      .filter(c => !c.deleted && (!filter || this.filterHits(c.apiSymbol)))
      .map(c =>
      <CoinRow
        key={c.id}
        coinItem={c}
        selected={c.id === selectedCoin}
        favorite={this.isFavorite(c.id)}
        isAdmin={adminMode}
      />
    )
  }

  render(){
    const { filterFavorites, filter } = this.state
    const coinsList = this.getList()

    return(
      <fb className="coinsList">
        <fb className='logoRow'>
          {/* <fb className="icon icon-poll logoIcon"></fb> */}
          <fb className="logoText">CRYPTORUNUP</fb>
          <fb className="alpha">ALPHA</fb>
        </fb>
        <fb className='actionRow'>
            <CoinsFilter filter={filter} setFilterString={(str) => { this.setState({ filter: str }) }} />
            <fb
              className={cn({ icon: 1, flagIcon: 1, 'icon-flag': 1, active: filterFavorites })}
              onClick={() => this.setState({ filterFavorites: !filterFavorites })}
            ></fb>
        </fb>
        <fb className='coinsListContent' onClick={this.listClicked}>
          <AutoSizer>
            {({ height, width }) => (
              <List
                width={width}
                height={height}
                rowCount={coinsList.length}
                rowHeight={40}
                rowRenderer={({key, index, isScrolling, isVisible, style}) =>
                  <div key={key} style={style}>{coinsList[index]}</div>
                }
              />
            )}
          </AutoSizer>
        </fb>
      </fb>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/coinslist/index.js